<ng-container *transloco="let t; read: TRANSLATION_SCOPE">
  <ng-container *ngIf="authFacade.showSuccessMessage$ | async; else show">
    <h3 class="text-center">
      {{ t('success.header') | transloco }}
    </h3>
    <p class="f-size-sm my-4" [innerHtml]="t('success.message') | transloco"></p>

    <rx-button buttonClass="primary" [flexible]="true" [routerLink]="addAbsolutePathPrefix(authRoutes.Login)">
      {{ t('success.button') | transloco }}
    </rx-button>
  </ng-container>
  <ng-template #show>
    <h3 class="text-center mb-4">
      {{ t('header') | transloco }}
    </h3>
    <p class="f-size-sm my-4" [innerHtml]="t('message') | transloco"></p>
    <rx-alert *ngIf="authFacade.error$ | async as error" type="danger" [message]="error"></rx-alert>

    <rx-button
      type="button"
      buttonClass="primary"
      [flexible]="true"
      (click)="authFacade.activateAccount()"
      [disabled]="authFacade.isLoading$ | async"
    >
      <span *ngIf="(authFacade.isLoading$ | async) === false; else isLoading">{{ t('button.active') | transloco }}</span>
      <ng-template #isLoading>{{ t('button.loading') | transloco }}</ng-template>
    </rx-button>
  </ng-template>
</ng-container>
